import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Create the root element for rendering the React app
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component into the root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);